import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter, Route, Redirect } from 'react-router-dom';

const PrivateRoute = ({
  component: Component,
  account,
  appInfo,
  variant,
  archive,
  key,
  form,
  keepDirtyOnReinitialize,
  Roles,
  ...otherProps
}) => (
  <Route
    {...otherProps}
    render={(props) => {
      if (!account.authenticated && !process.env.REACT_APP_API_ROOT && props.location.pathname.indexOf('/admin') === -1) {
        if (appInfo['LOGIN_REDIRECT_URL']) {
          window.location.replace(`${appInfo['LOGIN_REDIRECT_URL']}account/login`);
        }
        return '';
      }
      return (!Roles
        || (Roles && account.Roles.filter(item => Roles.indexOf(item.Name) !== -1).length > 0)) ? (
          <Component
            {...variant ? { variant } : {}}
            {...archive ? { archive } : {}}
            {...key ? { key } : { key: props.location.pathname }}
            {...form ? { form } : {}}
            {...keepDirtyOnReinitialize !== null ? { keepDirtyOnReinitialize } : {}}
            {...props}
          />
        ) : (
          <Redirect to="/" />
        );
    }}
  />
);

PrivateRoute.propTypes = {
  component: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.element,
  ]).isRequired,
  account: PropTypes.shape({
    authenticated: PropTypes.bool.isRequired,
    Roles: PropTypes.arrayOf(PropTypes.shape({
      Name: PropTypes.string.isRequired,
    })).isRequired,
  }).isRequired,
  variant: PropTypes.string,
  archive: PropTypes.bool,
  key: PropTypes.string,
  form: PropTypes.string,
  keepDirtyOnReinitialize: PropTypes.bool,
  Roles: PropTypes.arrayOf(PropTypes.string),
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
};

PrivateRoute.defaultProps = {
  variant: null,
  key: null,
  form: null,
  keepDirtyOnReinitialize: null,
  Roles: null,
  archive: false,
};

const mapStateToProps = store => ({
  account: store.account,
  appInfo: store.appInfo,
});

export default withRouter(connect(mapStateToProps)(PrivateRoute));



// WEBPACK FOOTER //
// ./src/components/common/PrivateRoute.js